<template>
  <div class="App">
    <router-view />
  </div>
</template>




<script setup>

</script>




<style scoped>


</style>